/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Review_Pro1Inputs */

const en_fc_home_review_pro1 = /** @type {(inputs: Fc_Home_Review_Pro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costs nothing. No account, watermark or export limit.`)
};

/**
* | output |
* | --- |
* | "Costs nothing. No account, watermark or export limit." |
*
* @param {Fc_Home_Review_Pro1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_review_pro1 = /** @type {((inputs?: Fc_Home_Review_Pro1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Review_Pro1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_review_pro1(inputs)
});
export { fc_home_review_pro1 as "fc.home.review.pro1" }